import TablePagination from "@material-ui/core/TablePagination";

const Pagination = ({
  totalEntry,
  recordPerPage,
  setRecordPerPage,
  currentPage,
  setCurrentPage,
  resultPage,
  setResultPage,
  screenWidth,
}) => {
  /**
   * A ... :
   * -
   *
   * @param {dict} pageNumber
   */
  const handleChangePage = (event, pageNumber) => {
    setCurrentPage(pageNumber + 1);
    setResultPage(resultPage + recordPerPage);
  };

  return (
    <TablePagination
      component="div"
      count={totalEntry}
      labelRowsPerPage=""
      page={currentPage - 1}
      onPageChange={handleChangePage}
      rowsPerPage={recordPerPage}
      rowsPerPageOptions={[2, 10, 25, 50, 100]}
      onRowsPerPageChange={(event) =>
        setRecordPerPage(Number(event.target.value))
      }
      onClick={() => {}}
    />
  );
};

export default Pagination;
